import { http } from "@/api/http";
import { getMailboxOAuthStatus } from "@/api/candidatePages";
import type { ConnectedServicesSummaryResponse } from "@/types/connectedServices";

export { getMailboxOAuthStatus };

export async function getConnectedServicesSummary(
  signal?: AbortSignal,
): Promise<ConnectedServicesSummaryResponse> {
  const response = signal
    ? await http.get<ConnectedServicesSummaryResponse>("/account/connected-services", { signal })
    : await http.get<ConnectedServicesSummaryResponse>("/account/connected-services");
  return response.data;
}
